import React from 'react';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import {
    BsArrowReturnLeft,
    BsFillBackspaceFill,
} from 'react-icons/bs';

class NumberTextField extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'isDisplayingDropDown': false
        }

        this.ref = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    };

    handleClickOutside(event) {
        if (this.ref.current && !this.ref.current.contains(event.target)) {
            this.setState({ 'isDisplayingDropDown': false })
        }
    }

    sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    render() {
        const iconStyle = { }

        if (!this.props.showDigitsKeyPad) {
            return <Input
                {...this.props} />
        }

        return <div ref={this.ref}
                onFocus={(e) => {
                    this.setState({ 'isDisplayingDropDown': true })
                }}
            >
            <Input
                {...this.props} />
            <Container
                className='DropDownTextField'
                style={{
                    'visibility':
                        this.state.isDisplayingDropDown ?
                        'visible' : 'hidden',
                    'maxWidth': '320px',
                }}>
                <Row>
                {
                    [
                        ...[7, 8, 9, 4, 5, 6, 1, 2, 3].map((x) => {
                            return [x, x, 4]
                        }),
                        ['0', '0', 8],
                        ['.', '.', 4],
                        [
                            'Delete',
                            <BsFillBackspaceFill style={iconStyle} />,
                            8,
                        ],
                        [
                            'Enter', 
                            <BsArrowReturnLeft style={iconStyle} />,
                            4,
                        ],
                    ].map((x) => {
                        return <Col xs={x[2]}><Button
                            style={{
                                'width': '100%',
                                'margin': '8px',
                            }}
                            onClick={(e) => {
                                const id = x[0]
                                if (id === 'Enter') {
                                    this.setState({ 'isDisplayingDropDown': false })
                                } else if (id === 'Delete') {
                                    this.props.onChange({
                                        'target': {'value':
                                            this.props.value.substr(0,this.props.value.length-1)}
                                    })
                                } else if (id === '.') {
                                    this.props.onChange({'target': {'value':
                                        this.props.value.replaceAll(/[^0-9]/g, '') + '.'}})
                                } else {
                                    this.props.onChange({'target': {'value': this.props.value + id}})
                                }
                            }}
                        >{x[1]}</Button></Col>
                    })
                }
                </Row>
            </Container>
        </div>
    }
}

export default NumberTextField
